import { computed } from 'vue';

export function useUser() {
  const userName = computed(() => (user) => {
    if (!user) {
      return '';
    }
    const firstName = user.first_name || '';
    const lastName = user.last_name || '';
    const name = `${firstName} ${lastName}`.trim();
    return name || '[No name]';
  });

  return { userName };
}
